import { jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { validateTidalLicense } from "../../../base/index.js";
function UcdBadgeInverted(props) {
  const { width = "100%", sx = {}, ...rest } = props;
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      "data-testid": "ucdBadgeInvertedLogo",
      titleAccess: "UCD Initiative",
      viewBox: "0 0 80 80",
      sx: { ...sx, height: "auto", width },
      ...rest,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M40 0C32.0888 0 24.3552 2.34596 17.7772 6.74121C11.1992 11.1365 6.07238 17.3836 3.04488 24.6927C0.0173731 32.0017 -0.774817 40.0444 0.768592 47.8036C2.312 55.5629 6.12166 62.6902 11.7158 68.2843C17.3099 73.8784 24.4371 77.688 32.1964 79.2314C39.9556 80.7748 47.9983 79.9827 55.3074 76.9552C62.6164 73.9277 68.8635 68.8008 73.2588 62.2228C77.654 55.6448 80 47.9112 80 40C80 29.3913 75.7858 19.2172 68.2843 11.7157C60.7829 4.21427 50.6087 0 40 0ZM40 66.3208C34.6692 66.3281 29.4629 64.7097 25.0756 61.6817L15.3091 64.3003L17.9704 54.3812C14.771 49.4769 13.2983 43.6459 13.7854 37.8106C14.2725 31.9753 16.6916 26.4691 20.6597 22.1631C24.6279 17.8571 29.9186 14.9973 35.6947 14.0362C41.4709 13.0751 47.4026 14.0675 52.5514 16.8565C57.7001 19.6454 61.7718 24.0716 64.1223 29.4348C66.4727 34.7979 66.9676 40.7917 65.5288 46.4677C64.0899 52.1437 60.7994 57.1779 56.1779 60.7736C51.5564 64.3694 45.8678 66.3214 40.0122 66.3208H40ZM47.3738 28.152C45.8421 28.1717 44.3452 28.6106 43.0453 29.4208C41.7454 30.2311 40.6922 31.3819 40 32.7484C39.3084 31.3815 38.2554 30.2303 36.9553 29.42C35.6553 28.6096 34.1581 28.1711 32.6263 28.152C27.9506 28.152 24.1661 32.1868 24.1661 37.1677C24.1661 42.1486 28.7991 46.8488 32.6263 49.7055C34.9943 51.5027 37.4556 53.1735 40 54.7108C42.5444 53.1735 45.0058 51.5027 47.3738 49.7055C51.201 46.8488 55.8401 42.1425 55.8401 37.1677C55.8401 32.1929 52.0495 28.152 47.3738 28.152Z",
          fill: "white"
        }
      )
    }
  );
}
validateTidalLicense();
export {
  UcdBadgeInverted
};
//# sourceMappingURL=UcdBadgeInverted.js.map
